module.exports = __webpack_public_path__ + "img/chongzhi2.d3f08c77.png";